<ng-container [ngSwitch]="mainService.getShopPortalLayoutKind()">
  <app-open-orders-webshop *ngSwitchDefault></app-open-orders-webshop>
  <!-- <app-open-orders-old *ngSwitchCase="0"></app-open-orders-old> -->
</ng-container>
